var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InputComponent',_vm._b({model:{value:(_vm.comp),callback:function ($$v) {_vm.comp=_vm._n($$v)},expression:"comp"}},'InputComponent',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }